import { createContext, useContext, useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const YouCancelProcessContext = createContext({
  cancelModal: null,
  setCancelModal: () => undefined,
});

export const YouCancelProcessProvider = ({ children }) => {
  const [cancelModal, setCancelModal] = useState(null);

  const updateCancelModal = useCallback((modal) => {
    setCancelModal(modal || null);
  }, []);

  const value = useMemo(
    () => ({ cancelModal, setCancelModal: updateCancelModal }),
    [cancelModal, updateCancelModal],
  );

  return (
    <YouCancelProcessContext.Provider value={value}>
      {children}
    </YouCancelProcessContext.Provider>
  );
};

YouCancelProcessProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useYouCancelProcess = () => useContext(YouCancelProcessContext);

export default YouCancelProcessProvider;
